import {
  CalendarCheck,
  CalendarDays,
  Calendar,
  Clock,
  User,
  Video,
  Quote,
} from "lucide-react";
import Badge from "../components/Badge";
import LoadingSkeleton from "../components/LoadingSkeleton";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "../lib/useQuery";
import { getSessions } from "../lib/queries";

function SessionCard({ session }) {
  const isCompleted = session.status === "completed";

  return (
    <div className="p-5 rounded-xl border border-gray-200 hover:shadow-sm transition-all">
      <div className="flex items-center justify-between mb-3">
        <span className="font-semibold text-gray-900">{session.type}</span>
        <Badge variant={isCompleted ? "success" : "info"}>
          {isCompleted ? "Completada" : "Programada"}
        </Badge>
      </div>

      <div className="flex flex-wrap gap-4 text-sm text-gray-500">
        <span className="flex items-center gap-1.5">
          <Calendar size={14} /> {session.date}
        </span>
        <span className="flex items-center gap-1.5">
          <Clock size={14} /> {session.time}h
        </span>
        <span className="flex items-center gap-1.5">
          <User size={14} /> {session.mentor}
        </span>
      </div>

      {session.notes && (
        <div className="mt-3 p-3 bg-gray-50 rounded-lg text-sm text-gray-600 leading-relaxed flex gap-2">
          <Quote size={14} className="text-gray-300 shrink-0 mt-0.5" />
          {session.notes}
        </div>
      )}

      {!isCompleted && (
        <button className="mt-3 px-4 py-2 rounded-lg bg-brand hover:bg-brand-dark text-white text-sm font-medium transition-all flex items-center gap-2">
          <Video size={14} />
          Unirse a la Llamada
        </button>
      )}
    </div>
  );
}

export default function Sessions() {
  const { user } = useAuth();
  const { data: sessions, loading } = useQuery(() => getSessions(user.id), [user.id]);

  if (loading) return <LoadingSkeleton />;

  const completed = sessions?.filter((s) => s.status === "completed") ?? [];
  const scheduled = sessions?.filter((s) => s.status === "scheduled") ?? [];

  return (
    <div className="animate-fade-in grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div className="px-4 md:px-6 py-4 border-b border-gray-100">
          <h3 className="font-semibold text-gray-900 flex items-center gap-2">
            <CalendarCheck size={18} className="text-emerald-500" />
            Sesiones Completadas
          </h3>
        </div>
        <div className="p-4 md:p-6 space-y-4">
          {completed.map((s) => (
            <SessionCard key={s.id} session={s} />
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div className="px-4 md:px-6 py-4 border-b border-gray-100">
          <h3 className="font-semibold text-gray-900 flex items-center gap-2">
            <CalendarDays size={18} className="text-brand-accent" />
            Próximas Sesiones
          </h3>
        </div>
        <div className="p-4 md:p-6 space-y-4">
          {scheduled.map((s) => (
            <SessionCard key={s.id} session={s} />
          ))}
        </div>
      </div>
    </div>
  );
}
